import styled from 'styled-components';

export default styled.div`
  width: 215px;
  text-overflow: ellipsis;
  overflow: hidden;
`;
